import PropTypes from 'prop-types';
import get from 'lodash/get';

import Popover from '../../../shared/Popover';
import FavoriteMenuOption from '../../../shared/menu/FavoriteMenuOption';
import ProfileNavMenuOption from '../../../shared/menu/ProfileNavMenuOption';
import ShareMenuOption from '../../../shared/menu/ShareMenuOption';
import withOutsideClickControl from '../../../../decorators/withOutsideClickControl';

import css from './schedule-card-actions.module.scss';

const menutOptionMap = {
  Follow: FavoriteMenuOption,
  Share: ShareMenuOption,
  Profile: ProfileNavMenuOption,
};

const getMenuOption = (item) => menutOptionMap[item];

// exported for testing
export const ScheduleCardActions = (props) => {
  const {
    guideItem = {},
    isMobile,
    isOpen,
    handleOnClick,
    containerProps,
  } = props;

  const defaultAction = get(guideItem, 'behaviors.default.actionName');
  const menuItems =
    defaultAction === 'Menu' && get(guideItem, 'actions.menu.items');

  if (!menuItems) {
    return null;
  }

  return (
    <div className={css.container} {...containerProps}>
      <div className={css.menu} onClick={handleOnClick}>
        <div className={css.dot} />
      </div>
      <Popover
        isOpen={isOpen}
        className={css.popover}
        contentClassName={css.popoverContent}
        pointerClassName={css.popoverPointer}
      >
        {menuItems.map((menuItem) => {
          const actionKey = get(menuItem, 'actionKey');
          const MenuOption = getMenuOption(actionKey);
          if (!MenuOption) {
            return null;
          }
          const menuAction = get(guideItem, [
            'actions',
            actionKey.toLowerCase(),
          ]);
          const actionTitle = get(menuItem, 'title');
          return (
            <MenuOption
              action={menuAction}
              guideItem={guideItem}
              isMobile={isMobile}
              title={actionTitle}
              key={actionKey}
            />
          );
        })}
      </Popover>
    </div>
  );
};

ScheduleCardActions.propTypes = {
  guideItem: PropTypes.object.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  containerProps: PropTypes.object.isRequired,
};

export default withOutsideClickControl(ScheduleCardActions, true);
